import { render, staticRenderFns } from "./DetailChangesList.vue?vue&type=template&id=29c31b32&scoped=true"
import script from "./DetailChangesList.vue?vue&type=script&lang=js"
export * from "./DetailChangesList.vue?vue&type=script&lang=js"
import style0 from "./DetailChangesList.vue?vue&type=style&index=0&id=29c31b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c31b32",
  null
  
)

export default component.exports